import { useEffect, useRef } from 'react'
import type { SubtitleLine } from './useSubtitles'
import { STT_LANGS } from './useSubtitles'
import type { SttLang } from './useSubtitles'

interface Props {
  lines: SubtitleLine[]
  partial: SubtitleLine | null
  lang: SttLang
  onLangChange: (lang: SttLang) => void
}

const LANG_LABELS: Record<string, string> = {
  '': 'AUTO',
  en: 'EN',
  fr: 'FR',
  de: 'DE',
  it: 'IT',
  pl: 'PL',
  es: 'ES',
  pt: 'PT',
  nl: 'NL',
}

export default function SubtitleBar({ lines, partial, lang, onLangChange }: Props) {
  const bottomRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [lines, partial])

  return (
    <div className="absolute top-0 right-0 bottom-12 w-[15%] z-40 bg-zinc-900/90 border-l border-zinc-800 flex flex-col overflow-hidden">
      <div className="flex-1 overflow-y-auto flex flex-col justify-end px-2 py-2">
        <div className="flex flex-col gap-1">
          {lines.map(line => (
            <p key={line.id} className="text-xs leading-relaxed text-white break-words">
              {line.text}
            </p>
          ))}
          {partial && (
            <p className="text-xs leading-relaxed text-zinc-500 italic break-words">
              {partial.text}
            </p>
          )}
          <div ref={bottomRef} />
        </div>
      </div>
      <div className="flex flex-nowrap gap-0.5 px-1 py-1 border-t border-zinc-800 justify-center overflow-x-auto">
        {STT_LANGS.map(l => (
          <button
            key={l || '_auto'}
            onClick={() => onLangChange(l)}
            className={`px-1.5 py-0.5 text-[10px] rounded ${
              lang === l
                ? 'bg-blue-600 text-white'
                : 'bg-zinc-800 text-zinc-400 hover:bg-zinc-700'
            }`}
          >
            {LANG_LABELS[l]}
          </button>
        ))}
      </div>
    </div>
  )
}
